document.addEventListener("turbolinks:load", () => {

  $('#operating_costs').on('cocoon:after-insert', function(e, insertedItem) {
    add_masks();
  });
  
});
